export default __webpack_public_path__ + "static/media/ada.3f61b438.png";